export const LOADING_AUDIENCES_ACTIONS = "LOADING_AUDIENCES_ACTIONS";
export const SAVE_LOADING_AUDIENCES_ACTIONS = "SAVE_LOADING_AUDIENCES_ACTIONS";
export const GET_AUDIENCES_ACTIONS = "GET_AUDIENCES_ACTIONS";
export const FORM_FAIL = "FORM_FAIL";
export const AUDIENCES_ACTIONS_FAIL = "AUDIENCES_ACTIONS_FAIL";
export const EMAIL_ERROR = "EMAIL_ERROR";
export const LOADING_EMAIL_SEND = "LOADING_EMAIL_SEND";
export const DELETE_AUDIENCE = "DELETE_AUDIENCE";
export const UPDATE_AUDIENCE = "UPDATE_AUDIENCE";
export const CREATE_AUDIENCE = "CREATE_AUDIENCE";
export const GET_DATA_BOSS = "GET_DATA_BOSS";
export const RESET_DATA_BOSS = "RESET_DATA_BOSS";